var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 20.6467V2.24054C0 0.752694 1.56669 -0.21424 2.89663 0.452785L20.5665 9.315C22.0128 10.0404 22.044 12.0935 20.6203 12.8625L2.95047 22.4064C1.61793 23.1261 0 22.1611 0 20.6467Z","fill":"white"}));
}

PlayButton.defaultProps = {"width":"22","height":"23","viewBox":"0 0 22 23","fill":"none"};

module.exports = PlayButton;

PlayButton.default = PlayButton;
